export default __webpack_public_path__ + "static/media/editIcon.4881adce.svg";